export default "__VITE_ASSET__q1jzHCeb__"